import script from "./RouterBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouterBox.vue?vue&type=script&setup=true&lang=ts"

import "./RouterBox.vue?vue&type=style&index=0&id=b8b2d174&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8b2d174"]])

export default __exports__